/**
 * @file index.tsx
 * @author markJia(markjia@tencent.com)
 */
import { MultipleSelect as InnerSelect } from './MultipleSelect';
import { Option } from '../Select/Option';
import { MultipleSelectContainer } from './MultipleSelectContainer';
export { SELECT_MAX_COUNT_NODE_KEY } from './util';
export var MultipleSelect = Object.assign(InnerSelect, {
  Option: Option,
  Container: MultipleSelectContainer
});